<template>
    <el-dialog title="修改推广like" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
        <el-form label-width="80px" ref="form" :model="form">
            <el-form-item label="like数量:">
                <el-input v-model.trim="form.amount" @input="form.amount = form.amount.replace(/[^0-9]/g, '')"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="handleClose">取消</el-button>
                <el-button type="primary" :loading="loading" @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import serverApi from '../../../server/index';
export default {
    props: ['dialogVisible', 'data'],
    data() {
        return {
            form: {
                amount: '',
            },
            loading: false,
        };
    },

    methods: {
        onSubmit() {
            this.loading = true;
            const params = {
                id: this.data._id,
                promotion_like: Number(this.form.amount),
            };
            serverApi
                .updateGptsLike(params)
                .then(res => {
                    if (res.data.code === 0) {
                        this.$message({
                            message: 'Submit success',
                            type: 'success',
                        });
                        this.$emit('closeModal', true);
                    } else {
                        this.$message({
                            message: res.data.msg || res.data.error,
                            type: 'error',
                        });
                    }
                    this.handleClose();
                    this.$emit('update');
                })
                .catch(e => {
                    this.$message({
                        message: e.data.error || e.data.msg,
                        type: 'error',
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleClose() {
            this.$emit('closeModal', false);
        },
    },
    mounted() {
        this.form.amount = this.data.promotion_like;
    },
};
</script>
